import {BaseWebComponentView} from '../../../framework/BaseWebComponentView';
import {GzCustomTemplateListWebComponent} from "../../../ui/gzCustomTemplateList";
import {html} from "lit";
import {
  IntegrationsMarketplaceGridAvailableNirvanaDataProvider
} from "../dataProvider/IntegrationsMarketplaceGridAvailableNirvanaDataProvider";
import {GzDialogWebComponent} from "../../../ui/gzDialog";
import {htmlEncode} from "../../../utils/escape.utils";
import {translateFn} from "../../../utils/translator.helper";
import {GzDialog} from "../../../ui/gzDialog/component/GzDialog";
import {computeGridAttributes} from "../../common/utils";
import {DEFAULT_GAP} from "../../common/constants";
import {IntegrationActionContext} from "../../integrationsMarketplaceGridInstalled/types";
import {SaveIntegrationWebComponent} from "../../saveIntegration";
import {SaveIntegrationEvents} from "../../saveIntegration/types";
import {AccountDetailsEvents} from "../../../accounts/common/accountDetails/types";
import {showCancelWarningDialog} from "../../../tagsManager/helpers/commonFunctions";


export class IntegrationsMarketplaceGridAvailableView extends BaseWebComponentView {

  private resizeObserver: ResizeObserver;

  public dom: {
    $wrapper: HTMLElement;
    $cardboardAvailableGrid: GzCustomTemplateListWebComponent;
  };
  private createIntegrationDialog: GzDialogWebComponent;

  getDomElements() {
    this.dom.$wrapper = this.shadow.querySelector('.wrapper');
    this.dom.$cardboardAvailableGrid = this.shadow.querySelector('#cardboard_available_grid') as GzCustomTemplateListWebComponent;
  }

  buildView() {
    this.buildCardboardAvailableGrid();
    this.gridResizeListener();
  }

  private availableCardsRenderer(itemData: any) {
    return html`
      <gz-integrations-marketplace-card @action-button-click="${this.handleLinkClick}"  @link-click="${this.handleLinkClick}" .data="${itemData}"></gz-integrations-marketplace-card>
    `;
  }

  private readonly handleLinkClick = (event: any) => {
    this.goToConfiguration(IntegrationActionContext.Create, null, event.detail.data.type);
  };

  public goToConfiguration(action: IntegrationActionContext, id: string | null, type: number): void {
      console.log('goToConfiguration', action, id);
      const saveIntegrationComponent = new SaveIntegrationWebComponent();
      saveIntegrationComponent.actionContext = action;
      saveIntegrationComponent.integrationId = id;
      saveIntegrationComponent.type = type;

      let windowTitle = htmlEncode(translateFn('Create integration'));
      if(action === IntegrationActionContext.Edit) {
      windowTitle = htmlEncode(translateFn('Edit integration'));
    }
    const windowConfigs: GzDialog = {
      headline: windowTitle,
      bodyContent: saveIntegrationComponent,
      isOpen: true,
      closableOutsideBox: false,
      isWindow: true,
      onCloseHandler: showCancelWarningDialog.bind(this, this.closeEditTagWindow.bind(this)),
    };

    this.createIntegrationDialog= GzDialogWebComponent.buildDialogElement(
      windowConfigs,
      document.querySelector('.mainContainer') as HTMLElement
    );

    saveIntegrationComponent.addEventListener(SaveIntegrationEvents.Cancel, showCancelWarningDialog.bind(this, this.closeEditTagWindow.bind(this)));

    saveIntegrationComponent.addEventListener(SaveIntegrationEvents.ReloadGrid, () => {
      this.createIntegrationDialog.close();
      this.reloadGridItems();
    });

    saveIntegrationComponent.injectDependencies(this.dependencies);
    saveIntegrationComponent.start().then().catch();
  }

  private closeEditTagWindow() {
    if (this.createIntegrationDialog === null) {
      return;
    }

    this.createIntegrationDialog.dismiss();
    this.reloadGridItems();
  }


  private reloadGridItems(): void {
    this.dom.$wrapper.dispatchEvent(
      new CustomEvent(SaveIntegrationEvents.ReloadGrid, {
        bubbles: true,
        composed: true,
      })
    );
  }


  private buildCardboardAvailableGrid() {
    const grid = this.dom.$cardboardAvailableGrid;
    grid.itemRenderer = this.availableCardsRenderer.bind(this);
    const {
      columns,
      pageSize,
      pageSizeOptions
    } = computeGridAttributes(grid);
    grid.columns = columns;
    grid.pageSize = pageSize;
    grid.pageSizeOptions = pageSizeOptions;
    grid.gap = DEFAULT_GAP;

    grid.dataProvider = new IntegrationsMarketplaceGridAvailableNirvanaDataProvider(this.dependencies);

    grid.injectDependencies(this.dependencies);
    grid.start();
  }

  private gridResizeListener() {
    this.resizeObserver = new ResizeObserver(() => this.handleResize());
    this.resizeObserver.observe(this.dom.$cardboardAvailableGrid);
  }

  public unobserveGridResize() {
    this.resizeObserver.unobserve(this.dom.$cardboardAvailableGrid);
  }

  handleResize() {
    const grid = this.dom.$cardboardAvailableGrid;

    const {
      columns: newNumberOfColumns,
      pageSize: newPageSize,
      pageSizeOptions: newPageSizeOptions
    } = computeGridAttributes(grid);
    // check if the number of columns needs to change
    if (grid.columns !== newNumberOfColumns) {
      grid.columns = newNumberOfColumns;
      grid.pageSize = newPageSize;
      grid.pageSizeOptions = newPageSizeOptions;
      // Update the grid view
      grid.controller.render();
    }
  }

}
